<template>
  <div class="wrapper">
    <div class="demo-page intro-card" v-if="page === 0">
      <h2>Welcome!</h2>
      <img src="@/assets/welcome.svg" alt="" id="hero-img" />
      <p>
        Kaado works by unifying all your different productivity needs - habits,
        learning and much more. Everything is organized in
        <em>cards</em>, so let's create some:
      </p>
      <button class="button button-primary button-right" @click="page += 1">
        I'm In!
      </button>
    </div>

    <div class="demo-page intro-card" v-if="page === 1">
      <h2>Learning</h2>
      <img src="@/assets/learn2.svg" alt="" id="hero-img" />

      <p>
        Learning is a big part of life, and we wouldn't miss it here. In Kaado
        learnings works via flash cards: Small units of information structured
        in a question-answer format.
      </p>
      <button class="button button-primary button-right" @click="page += 1">
        Create my first card
      </button>
    </div>

    <div class="demo-page" v-if="page === 2">
      <h2>Create a learning card</h2>
      <p>
        What do you want to learn? You can use Kaado to memorize any kind of
        concept, word or phrase.
      </p>
      <p>You can create your first own learning card...</p>

      <div id="edit">
        <div class="card learn" id="edit-card">
          <div id="card-heading-wrapper">
            <h2 class="card-heading" id="label-front">Front</h2>
          </div>

          <textarea
            class="card-content"
            name="front"
            id="card-front"
            v-model="cards[0].front"
            @input="savingState = 'not saved'"
            @change="saveCard"
          ></textarea>
          <div>
            <h2 class="card-heading" id="label-back">Back</h2>
          </div>
          <textarea
            name="back"
            class="card-content"
            id=""
            v-model="cards[0].back"
            @input="savingState = 'not saved'"
            @change="saveCard"
          ></textarea>

          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[0].front && cards[0].back"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
      </div>

      <p>...or use one of the premade ones:</p>
      <div id="premade-card-select">
        <div
          class="premade-card card"
          @click="cards[1].activated = !cards[1].activated"
        >
          <span> {{ cards[1].front }} </span>
          <div id="queue-spacer"></div>
          <span> {{ cards[1].back }} </span>
          <br />
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[1].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
        <div
          class="premade-card card"
          @click="cards[2].activated = !cards[2].activated"
        >
          <span> {{ cards[2].front }} </span>
          <div id="queue-spacer"></div>

          <span> {{ cards[2].back }} </span>
          <br />
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[2].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
        <div
          class="premade-card card"
          @click="cards[3].activated = !cards[3].activated"
        >
          <span> {{ cards[3].front }}</span>
          <div id="queue-spacer"></div>
          <span> {{ cards[3].back }} </span>
          <br />
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[3].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
      </div>
      <button class="button button-primary button-right" @click="page += 0.5">
        Next
      </button>
    </div>

    <div class="demo-page intro-card" v-if="page === 2.5">
      <h2>Habits</h2>
      <img src="@/assets/habit.svg" alt="" id="hero-img" />

      <p>
        Apart from learning, Kaado also has habits - habits are recurring
        activities you want to do. You can set how often habits should occur and
        Kaado will prompt you to do them inbetween your learning cards.
      </p>
      <button class="button button-primary button-right" @click="page += 0.5">
        Create a habit card
      </button>
    </div>

    <div class="demo-page" v-if="page === 3">
      <h2>Create a habit card</h2>

      <div class="card" id="edit-card" :class="cards[4].type">
        <div id="card-heading-wrapper">
          <h2
            class="card-heading"
            v-if="cards[4].type === 'learn'"
            id="label-front"
          >
            Front
          </h2>
          <h2 class="card-heading" v-else>Content</h2>
        </div>
        <textarea
          class="card-content"
          name="front"
          id="card-front"
          v-model="cards[4].front"
          @input="savingState = 'not saved'"
          @change="saveCard"
        ></textarea>
        <div></div>

        <p
          v-if="this.cards[4].type == 'habit' || this.cards[4].type == 'check'"
          id="interval-selector"
          class="extra-selector"
        >
          Show every
          <input class="input"
            type="number"
            v-model="cards[4].interval"
            id="interval"
            default="1"
            @change="saveCard"
          />

          <span @click="switchUnit(4)" class="switchableText">
            {{ cards[4].unit }} </span
          >.
        </p>
        <p
          v-if="this.cards[4].type == 'readingList'"
          id="started-reading-wrapper"
          class="extra-selector"
        >
          <input class="input"
            type="checkbox"
            :checked="cards[4].interval == 0"
            @change="setReadingStarted($event)"
            name="started-reading"
            id="started-reading"
          />
          <label for="started-reading">Started Reading</label>
        </p>
      </div>

      <p>...or use one of the premade ones:</p>
      <div id="premade-card-select">
        <div
          class="premade-card card"
          @click="cards[5].activated = !cards[5].activated"
        >
          <span> {{ cards[5].front }} </span>
          <div class="small">{{ cards[5].interval }} {{ cards[5].unit }}</div>
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[5].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
        <div
          class="premade-card card"
          @click="cards[6].activated = !cards[6].activated"
        >
          <span> {{ cards[6].front }} </span>

          <div class="small">{{ cards[6].interval }} {{ cards[6].unit }}</div>
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[6].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
        <div
          class="premade-card card"
          @click="cards[7].activated = !cards[7].activated"
        >
          <span> {{ cards[7].front }}</span>
          <div class="small">{{ cards[7].interval }} {{ cards[7].unit }}</div>
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[7].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
      </div>

      <button class="button button-primary button-right" @click="page += 0.5">
        Next
      </button>
    </div>

    <div class="demo-page intro-card" v-if="page === 3.5">
      <h2>Checks</h2>
      <img src="@/assets/check.svg" alt="" id="hero-img" />

      <p>
        Checks are similar to habits, but they are always questions about the
        (recent) past. You can use these to check in with yourself and see
        whether you are on track with your habits, goals and aspirations.
      </p>
      <button class="button button-primary button-right" @click="page += 0.5">
        Create a check card
      </button>
    </div>

    <div class="demo-page" v-if="page === 4">
      <h2>Create a check card</h2>

      <div class="card" id="edit-card" :class="cards[8].type">
        <div id="card-heading-wrapper">
          <h2
            class="card-heading"
            v-if="cards[8].type === 'learn'"
            id="label-front"
          >
            Front
          </h2>
          <h2 class="card-heading" v-else>Content</h2>
        </div>
        <textarea
          class="card-content"
          name="front"
          id="card-front"
          v-model="cards[8].front"
          @input="savingState = 'not saved'"
          @change="saveCard"
        ></textarea>
        <div></div>

        <p
          v-if="this.cards[8].type == 'habit' || this.cards[8].type == 'check'"
          id="interval-selector"
          class="extra-selector"
        >
          Show every
          <input class="input"
            type="number"
            v-model="cards[8].interval"
            id="interval"
            default="1"
            @change="saveCard"
          />

          <span @click="switchUnit(8)" class="switchableText">
            {{ cards[8].unit }} </span
          >.
        </p>
      </div>

      <p>...or use one of the premade ones:</p>
      <div id="premade-card-select">
        <div
          class="premade-card card"
          @click="cards[9].activated = !cards[9].activated"
        >
          <span> {{ cards[9].front }} </span>
          <div class="small">{{ cards[9].interval }} {{ cards[9].unit }}</div>
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[9].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
        <div
          class="premade-card card"
          @click="cards[10].activated = !cards[10].activated"
        >
          <span> {{ cards[10].front }} </span>
          <div class="small">{{ cards[10].interval }} {{ cards[10].unit }}</div>
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[10].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
        <div
          class="premade-card card"
          @click="cards[11].activated = !cards[11].activated"
        >
          <span> {{ cards[11].front }}</span>
          <div class="small">{{ cards[11].interval }} {{ cards[11].unit }}</div>
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[11].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
      </div>

      <button class="button button-primary button-right" @click="page += 0.5">
        Next
      </button>
    </div>

    <div class="demo-page intro-card" v-if="page === 4.5">
      <h2>To-Do</h2>
      <img src="@/assets/todo.svg" alt="" id="hero-img" />

      <p>
        To do lists - a classic. Instead of long, dreadful lists to-dos are also
        cards, so you have just one task at a time.
      </p>
      <button class="button button-primary button-right" @click="page += 0.5">
        Let's note down a to-do!
      </button>
    </div>

    <div class="demo-page" v-if="page === 5">
      <h2>Create a to-do card</h2>

      <div class="card" id="edit-card" :class="cards[12].type">
        <div id="card-heading-wrapper">
          <h2
            class="card-heading"
            v-if="cards[12].type === 'learn'"
            id="label-front"
          >
            Front
          </h2>
          <h2 class="card-heading" v-else>Content</h2>
        </div>
        <textarea
          class="card-content"
          name="front"
          id="card-front"
          v-model="cards[12].front"
          @input="savingState = 'not saved'"
          @change="saveCard"
        ></textarea>
        <div></div>

        <p
          v-if="
            this.cards[12].type == 'habit' || this.cards[12].type == 'check'
          "
          id="interval-selector"
          class="extra-selector"
        >
          Show every
          <input class="input"
            type="number"
            v-model="cards[12].interval"
            id="interval"
            default="1"
            @change="saveCard"
          />

          <span @click="switchUnit(12)" class="switchableText">
            {{ cards[12].unit }} </span
          >.
        </p>
        <p
          v-if="this.cards[12].type == 'readingList'"
          id="started-reading-wrapper"
          class="extra-selector"
        >
          <input class="input"
            type="checkbox"
            :checked="cards[12].interval == 0"
            @change="setReadingStarted($event)"
            name="started-reading"
            id="started-reading"
          />
          <label for="started-reading">Started Reading</label>
        </p>
      </div>

      <button class="button button-primary button-right" @click="page += 1">
        Next
      </button>
    </div>

    <div class="demo-page intro-card" v-if="page === 5.5">
      <h2>Reading List</h2>
      <img src="@/assets/reading.svg" alt="" id="hero-img" />

      <p>
        Books, articles, courses, talks...keep track of these with cards of type
        'readingList'. This kind of card will prompt you to regularly read a
        page until you are, eventually, all the way through.
      </p>
      <button class="button button-primary button-right" @click="page += 0.5">
        Create a reading list item
      </button>
    </div>

    <div class="demo-page" v-if="page === 6">
      <h2>Create a reading list card</h2>

      <div class="card" id="edit-card" :class="cards[13].type">
        <div id="card-heading-wrapper">
          <h2
            class="card-heading"
            v-if="cards[13].type === 'learn'"
            id="label-front"
          >
            Front
          </h2>
          <h2 class="card-heading" v-else>Content</h2>
        </div>
        <textarea
          class="card-content"
          name="front"
          id="card-front"
          v-model="cards[13].front"
          @input="savingState = 'not saved'"
          @change="saveCard"
        ></textarea>
        <div></div>

        <p
          v-if="
            this.cards[13].type == 'habit' || this.cards[13].type == 'check'
          "
          id="interval-selector"
          class="extra-selector"
        >
          Show every
          <input class="input"
            type="number"
            v-model="cards[13].interval"
            id="interval"
            default="1"
            @change="saveCard"
          />

          <span @click="switchUnit(13)" class="switchableText">
            {{ cards[13].unit }} </span
          >.
        </p>
        <p
          v-if="this.cards[13].type == 'readingList'"
          id="started-reading-wrapper"
          class="extra-selector"
        >
          <input class="input"
            type="checkbox"
            :checked="cards[13].interval == 0"
            @change="setReadingStarted($event)"
            name="started-reading"
            id="started-reading"
          />
          <label for="started-reading">Started Reading</label>
        </p>
      </div>

      <p>...or use one of the premade ones:</p>
      <div id="premade-card-select">
        <div
          class="premade-card card"
          @click="cards[14].activated = !cards[14].activated"
        >
          <Markdown :source="cards[14].front" />

          <br />
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[14].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
        <div
          class="premade-card card"
          @click="cards[15].activated = !cards[15].activated"
        >
          <Markdown :source="cards[15].front" />

          <br />
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[15].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
        <div
          class="premade-card card"
          @click="cards[16].activated = !cards[16].activated"
        >
          <Markdown :source="cards[16].front" />

          <br />
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[16].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
      </div>

      <button class="button button-primary button-right" @click="page += 1">
        Next
      </button>
    </div>

    <div class="demo-page intro-card" v-if="page === 6.5">
      <h2>Other Cards</h2>
      <img src="@/assets/fun.svg" alt="" id="hero-img" />

      <p>
        Only learning and to dos are no fun! Use the type 'other' to store
        inspirational quotes, cool images, your favorite memes or interesting
        websites. These cards will be randomly displayed between the other types
        of cards, bringing joy to each session.
      </p>
      <button class="button button-primary button-right" @click="page += 0.5">
        Add a card
      </button>
    </div>

    <div class="demo-page" v-if="page === 7">
      <h2>Create a card of type 'other'</h2>

      <div class="card" id="edit-card" :class="cards[17].type">
        <div id="card-heading-wrapper">
          <h2
            class="card-heading"
            v-if="cards[17].type === 'learn'"
            id="label-front"
          >
            Front
          </h2>
          <h2 class="card-heading" v-else>Content</h2>
        </div>
        <textarea
          class="card-content"
          name="front"
          id="card-front"
          v-model="cards[17].front"
          @input="savingState = 'not saved'"
          @change="saveCard"
        ></textarea>
        <div></div>
      </div>

      <p>...or use one of the premade ones:</p>
      <div id="premade-card-select">
        <div
          class="premade-card card"
          @click="cards[18].activated = !cards[18].activated"
        >
          <Markdown :source="cards[18].front" />

          <br />
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[18].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
        <div
          class="premade-card card"
          @click="cards[19].activated = !cards[19].activated"
        >
          <Markdown :source="cards[19].front" />

          <br />
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[19].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
        <div
          class="premade-card card"
          @click="cards[20].activated = !cards[20].activated"
        >
          <Markdown :source="cards[20].front" />

          <br />
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-if="cards[20].activated"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
      </div>

      <button class="button button-primary button-right" @click="page += 1">
        Next
      </button>
    </div>

    <div class="demo-page" v-if="page === 8">
      <h2>Add Public Collections</h2>
      <p>
        In Kaado, you profit from a growing collection of public collections.
        Feel free to add some of those to your cards right now - you can always
        edit or remove them later.
      </p>
      <div class="premade-card-wrapper">
        <div
          v-for="collection in publicCollections"
          :key="collection.id"
          class="card flex-card "
        >
          <div id="title-wrapper-collection">
            {{ collection.emoji }}
            <h3>
              {{ collection.name }}
            </h3>
          </div>

          <p>
            {{ collection.description }}
          </p>
          <button
            class="button"
            @click="addToLibrary(collection)"
            v-if="!this.alreadyAddedCollections.includes(collection.id)"
          >
            Add To Library
          </button>
          <div class="center small" v-else>
            <em>added</em>
          </div>
        </div>
      </div>
      <button class="button button-primary button-right" @click="page += 1">
        Next
      </button>
    </div>

    <div class="demo-page" v-if="page === 9">
      <h2>You are ready to go.</h2>
      <p>
        You have explored all card types. You are now ready to use your existing
        cards or add more.
      </p>
      <button
        class="button button-primary button-right"
        @click="setIntroFinished"
      >
        Let's go!
      </button>
    </div>
  </div>
</template>

<script>
import Markdown from "vue3-markdown-it";
import { supabase } from "../supabase";
import { v4 as uuidv4 } from "uuid";

export default {
  name: "Intro",
  data() {
    return {
      page: 0,
      cards: [
        {
          front: "",
          back: "",
          type: "learn",
          activated: true,
        },
        {
          activated: false,
          front: "What is the capital of Egypt?",
          back: "Cairo",
          type: "learn",
        },
        {
          activated: false,
          front: "When did the Roman Republic end?",
          back: "27 BC",
          type: "learn",
        },
        {
          activated: false,
          front: "What does '¿qué tal?' mean?",
          back: "How are you?",
          type: "learn",
        },
        {
          activated: true,
          front: "",
          back: "",
          type: "habit",
          interval: 1,
          unit: "days",
        },
        {
          activated: false,
          front: "Do one push-up",
          type: "habit",
          interval: 1,
          unit: "days",
        },
        {
          activated: false,
          front: "Take three deep breaths",
          type: "habit",
          interval: 2,
          unit: "hours",
        },
        {
          activated: false,
          front: "Clear your desk",
          type: "habit",
          interval: 3,
          unit: "days",
        },

        {
          activated: true,
          front: "",
          back: "",
          type: "check",
          interval: 1,
          unit: "days",
        },
        {
          activated: false,
          front: "Did you give yourself enough time to sleep last night?",
          type: "check",
          interval: 1,
          unit: "days",
        },
        {
          activated: false,
          front: "Do you have full glass of drinking water in reach?",
          type: "check",
          interval: 3,
          unit: "hours",
        },
        {
          activated: false,
          front: "Did you do something this week that makes you happy?",
          type: "check",
          interval: 7,
          unit: "days",
        },
        {
          activated: true,
          front: "",
          back: "",
          type: "todo",
        },
        {
          activated: true,
          front: "",
          back: "",
          type: "readingList",
          interval: 1,
        },
        {
          activated: false,
          front:
            "## Alice In Wonderland \n [Link: Project Gutenberg](https://www.gutenberg.org/files/11/11-h/11-h.htm)",
          type: "readingList",
          interval: 1,
        },
        {
          activated: false,
          front:
            "## Why Procrastinators Procrastinate \n[Link: Blogpost](https://waitbutwhy.com/2013/10/why-procrastinators-procrastinate.html)",
          type: "readingList",
          interval: 1,
        },
        {
          activated: false,
          front:
            "## Performing CPR  \n [Guide by Red Cross](https://www.redcross.org/take-a-class/cpr/performing-cpr/cpr-steps)",
          type: "readingList",
          interval: 1,
        },
        {
          activated: true,
          front: "",
          back: "",
          type: "standard",
        },
        {
          activated: false,
          front:
            "“You have power over your mind – not outside events. Realize this, and you will find strength.” -Marcus Aurelius ",
          type: "standard",
        },
        {
          activated: false,
          front:
            "![Girl with a Pearl Earring](https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/1665_Girl_with_a_Pearl_Earring.jpg/270px-1665_Girl_with_a_Pearl_Earring.jpg) \n ## Girl with a Pearl Erring \n ### Vermeer, 1665",
          type: "standard",
        },
        {
          activated: false,
          front:
            "## Triple Saw Music \n <https://www.vitling.xyz/toys/triple_saw/> \n Autogenerated background music site",
          type: "standard",
        },
      ],
      alreadyAddedCollections: [],
    };
  },
  methods: {
    setIntroFinished() {
      const filteredCollection = this.cards.filter((card) => {
        return card.activated && card.front !== "";
      });
      

      const id = uuidv4();

      const newCollection = {
        id: id,
        name: "My first collection",
        description: null,
        userId: supabase.auth.currentUser.id,
        public: false,
        emoji: "📔",
      };

      this.$store.dispatch("addCollection", newCollection).then(() => {
        for (const card of filteredCollection) {
          
          this.$store.dispatch("addCard", {
            id: uuidv4(),
            type: card.type,
            front: card.front,
            back: card.back || "",
            nextShown: new Date() / 1000,
            ease: 0,
            interval: card.interval,
            repetition: 0,
            unit: card.unit,
            pack_id: id,
            user_id: supabase.auth.currentUser.id,
            occurrences: 0,
          });
        }
      });

      this.$store.dispatch("setIntroFinished");
      // redirect to queue
      this.$router.push({ name: "Queue" });
    },

    convertUnixTimestampToReadableDatetime(timestamp) {
      if (timestamp > 1) {
        return "next due at: " + new Date(timestamp * 1000).toLocaleString();
      } else {
        return "fresh card - due now";
      }
    },

    setReadingStarted: function (event) {
      if (event.target.checked) {
        this.card.interval = 0;
      } else {
        this.card.interval = 1;
      }
    },
    switchUnit: function (index) {
      if (this.cards[index].unit === "days") {
        this.cards[index].unit = "hours";
      } else {
        this.cards[index].unit = "days";
      }
    },

    addToLibrary: function (collection) {
      this.$store.dispatch("cloneCollection", collection).then(() => {
        this.alreadyAddedCollections.push(collection.id);
      });
    },
  },
  mounted: function () {
    this.$store.dispatch("getPublicCollections");
  },
  computed: {
    publicCollections: function () {
      return this.$store.state.publicCollections;
    },
  },
  components: {
    Markdown,
  },
};
</script>